module.exports = require("core-js-pure/stable/instance/concat");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/concat.js
// module id = 22
// module chunks = 0 1